export default "<app-budget-table [columns]=\"columns\" [hasFooter]=\"true\"></app-budget-table>\n"